import React, { useEffect } from "react";
import { connect } from "react-redux";
import { formValueSelector, getFormInitialValues } from "redux-form";
import { Input } from "antd";
import plain from "redux-form/lib/structure/plain";

import styles from "../../v2Styles.module.css";

const RiskField = ({ input, likelihoodValue, consequenceValue, initialValue }) => {

  useEffect(() => {
    if (likelihoodValue && likelihoodValue.like_value && consequenceValue && consequenceValue.cons_value) {
      const calcValue = likelihoodValue.like_value * consequenceValue.cons_value;
      if (calcValue !== input.value) {
        input.onChange(likelihoodValue.like_value * consequenceValue.cons_value);
      }
    } else {
      input.onChange(null);
    }
  }, [likelihoodValue, consequenceValue])

  return (
    <div>
      <Input readOnly className={styles.TextField} value={input.value ? input.value : "N/A"} />
      <div style={{ fontSize: "12px", color: "orange" }}>
        {input.value && initialValue && initialValue !== input.value ?
          `Value is different than already saved value - ${initialValue}` : ""}
      </div>
    </div>
  )
}

export default connect((state, initialProps) => {
  return {
    likelihoodValue: (formValueSelector(initialProps.formName))(state, initialProps.likelihood),
    consequenceValue: (formValueSelector(initialProps.formName))(state, initialProps.consequence),
    initialValue: plain.getIn(getFormInitialValues(initialProps.formName)(state), initialProps.input.name)
  }
})(RiskField);
